<template>
  <q-btn @click="debounceClick" />
</template>

<script setup lang="ts">
import { debounce } from "quasar";

const props = withDefaults(
  defineProps<{
    delay?: number;
  }>(),
  {
    delay: 200,
  }
);

const emit = defineEmits(["click"]);

const debounceClick = debounce(() => {
  emit("click");
}, props.delay);

</script>

<style scoped></style>
